import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"
import { doc, onSnapshot, setDoc, updateDoc, arrayUnion, getDoc } from "firebase/firestore";
import { collection, getDocs } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyAavJIsTIx4metl8AZnsKtvHD5sQQmRx9k",
    authDomain: "sof-error.firebaseapp.com",
    databaseURL: "https://sof-error.firebaseio.com",
    projectId: "sof-error",
    storageBucket: "sof-error.appspot.com",
    messagingSenderId: "1019380696647",
    appId: "1:1019380696647:web:9f7c8fea8e26d46a015362"
};

export const bookTiles = (roomId, tiles) => {
    const app = initializeApp(firebaseConfig);
    const db = getFirestore();
    console.log("going to book", roomId, tiles)

    const docRef = doc(db, "aarathy", "building");
    return getDoc(docRef)
        .then(docSnap => {
            if (docSnap.exists()) {
                const building = docSnap.data();
                let room = building[roomId];
                if (!room) room = {};

                tiles.forEach(tileDetails => {
                    console.log(tileDetails.rowIndex, tileDetails.colIndex, room)
                    if (!room[tileDetails.rowIndex]) room[tileDetails.rowIndex] = [];

                    for (var ind = 0; ind < tileDetails.colIndex; ind = ind + 1) {
                        if (!room[tileDetails.rowIndex][ind]) {
                            room[tileDetails.rowIndex][ind] = { type: 'o' };
                        }
                    }
                    room[tileDetails.rowIndex][tileDetails.colIndex] = { type: 'b' }
                })
                const buildingRef = doc(db, "aarathy", "building");

                console.log("before firebase", buildingRef, roomId, room)
                updateDoc(buildingRef, {
                    [roomId]: room
                });


                console.log("Room data:", room);
            } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
            }
        });
}

export const getBuilding = (onSuccess) => {
    const app = initializeApp(firebaseConfig);
    const db = getFirestore();
    return onSnapshot(doc(db, "aarathy", "building"), (doc) => {
        onSuccess(doc.data());
    });
}